module.exports = __webpack_public_path__ + "img/brownish_attached.955d79a2.svg";